import { setState } from './helpers'

const orderMutations = {
  SET_ORDERS: setState('orders'),
  SET_ORDER: setState('order'),
  SET_ORDER_STATS: setState('orderStats')
}

export { orderMutations }
